import { render, staticRenderFns } from "./ProductOffersModal.vue?vue&type=template&id=10df123a&scoped=true&name=product-offers-modal&"
import script from "./ProductOffersModal.vue?vue&type=script&lang=js&"
export * from "./ProductOffersModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductOffersModal.vue?vue&type=style&index=0&id=10df123a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df123a",
  null
  
)

/* custom blocks */
import block0 from "./ProductOffersModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports